export type AnalyzerDataSettingForm = {
  analyzer_id?: number;
  disconnect_after_inactivity?: boolean;
  record_last_trace_in_live?: boolean;
};

export type AnalyzerDataSettingFormField = 'disconnect_after_inactivity';

export enum InstrumentType {
  ANALYZER = 0,
  SWITCH = 1,
}
